import React from 'react';

import { MultiFieldsFilterProvider } from './FilterFieldsManager';
import { FiltersDataManagerProvider } from './FiltersDataManager';
import { FiltersSettingsProvider } from './FiltersSettings';
import FiltersStateManager, { useStateManager } from './FiltersStateManager';
import FiltersRequiredManagerProvider from './FiltersRequiredManager/FiltersRequiredManagerProvider';

const defaultOnCompare = () => ({});

const defaultInitialValues = [{}];

export const FiltersCollection = ({
  children,
  controlled,
  initialValues = defaultInitialValues,
  onChange,
  onApply,
  emptyValues,
  initialDirty,
  onCompare = defaultOnCompare,
  favorites,
  onChangeFavorites,
  screen,
}) => {
  const {
    values,
    setFilterValue,
    setFilterValues,
    getFilterValue,
    getFilterEmptyValue,
    getFilterValues,
    onClearFilters,
    onApplyFilters,
    clear,
    dirty,
  } = useStateManager({
    controlled,
    initialValues,
    initialDirty,
    emptyValues,
    onChange,
    onApply,
  });

  const comparedCount = values?.length || 1;

  const compared = comparedCount > 1;

  const handleChangeCompared = () => {
    if (compared) {
      const [, baseCollection] = values;
      setFilterValues([baseCollection]);
    } else {
      const [baseCollection] = values;
      setFilterValues(onCompare(baseCollection));
    }
  };

  return (
    <FiltersRequiredManagerProvider>
      <FiltersDataManagerProvider screen={screen}>
        <FiltersStateManager.Provider
          value={{
            collection: true,
            setFilterValue,
            setFilterValues,
            getFilterEmptyValue,
            getFilterValue,
            getFilterValues,
            onClearFilters,
            onApplyFilters,
            clear,
            dirty,
          }}
        >
          <FiltersSettingsProvider
            favorites={favorites}
            onChangeFavorites={onChangeFavorites}
          >
            <MultiFieldsFilterProvider
              compared={compared}
              fieldsCount={comparedCount}
              onToggleFields={handleChangeCompared}
            >
              {children}
            </MultiFieldsFilterProvider>
          </FiltersSettingsProvider>
        </FiltersStateManager.Provider>
      </FiltersDataManagerProvider>
    </FiltersRequiredManagerProvider>
  );
};

export default FiltersCollection;
